var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZigZag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 50,
    viewBox: "0 0 194 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.87 29.25L160.43 45.61L143.98 29.25L127.54 45.61L111.1 29.25L96.6 43.68L82.09 29.25L65.65 45.61L49.2 29.25L32.76 45.61L16.32 29.25L0 45.49L1.82 47.31L16.32 32.88L32.76 49.24L49.2 32.88L65.65 49.24L82.09 32.88L96.6 47.32L111.1 32.88L127.54 49.24L143.98 32.88L160.43 49.24L176.87 32.88L191.38 47.31L193.19 45.49L176.87 29.25Z",
    fill: "#0B315E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.87 0L160.43 16.36L143.98 0L127.54 16.36L111.1 0L98.0598 12.98L98.0498 16.62L111.1 3.63L127.54 19.99L143.98 3.63L160.43 19.99L176.87 3.63L191.38 18.06L193.19 16.23L176.87 0Z",
    fill: "#FF9D00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZigZag);
export default __webpack_public_path__ + "static/media/zig-zag.71907f81253e487ceeb484fc739de29c.svg";
export { ForwardRef as ReactComponent };